import OtherConsmptionItems from "components/plastics/OtherConsumptionItems"
import Decisions from "pages/Application/Decisions"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col, Alert } from "reactstrap"
import ApplicationDetails from "./ApplicationDetails"
import BaseForm from "./BaseForm"
import Application from "services/applications/Application.service"
const appService = new Application(JSON.parse(localStorage.getItem("authUser")))

const BaseApplication = props => {
  const [showOtherConsumptionItems, setshowOtherConsumptionItems] =
    useState(false)

  const [isManuallyProcessed, setisManuallyProcessed] = useState(false)
  useEffect(() => {
    // Only show other items if service type is application type is auth to use plastics
    if (props.applicationData.service.id == 1) {
      setshowOtherConsumptionItems(true)
    }

    // Set manual processed
    if (props.applicationData.manually_processed != undefined) {
      setisManuallyProcessed(props.applicationData.manually_processed)
    }
  })
  const triggerFormSubmit = values => {
    props.submit(values)
  }

  const download = (path, name) => {
    appService
      .downloadAttachment(path)
      .then(response => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]))
          const link = document.createElement("a")
          link.href = url
          link.setAttribute("download", name)
          document.body.appendChild(link)
          link.click()
          link.remove()
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.title} | Staff</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">{props.title}</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    {props.description}
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

        {isManuallyProcessed ? <>
          <Alert color="info">
            Officer has marked this application to be archived. Please
            check the link below to see the unsigned certificate the officer
            uploaded.
          </Alert>
          <h6>
                <a
                  href="#"
                  onClick={e =>
                    download(
                      props.applicationData.manual_certificate.path,
                      props.applicationData.manual_certificate.file_name
                    )
                  }
                >
                  Download Unsigned Certificate{" "}
                  <i
                    className="fas fa-cloud-download-alt"
                    title="Download"
                    style={{ color: "green" }}
                  ></i>
                </a>
              </h6>
        </> : null}
        

          {showOtherConsumptionItems ? (
            <Row>
              <OtherConsmptionItems appDetails={props.applicationData} />
              <hr></hr>
            </Row>
          ) : null}

          <Row>
            <Col md={6}>
              <BaseForm
                formComponent={props.formComponent}
                submit={triggerFormSubmit}
              />
            </Col>
            <Col md={6}>
              <Decisions appDetails={props.applicationData} />
            </Col>
          </Row>
          <hr></hr>

          <Row>
            <Col md={12}>
              <ApplicationDetails
                appDetails={props.appDetails}
                attachments={props.attachments}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BaseApplication
